
<template>
  <div>
    <van-nav-bar
      title="座位预约"
      fixed
      placeholder
      left-text="返回"
      right-text="首页"
      left-arrow
      @click-left="goBack"
      @click-right="goHome"
    />
    <van-notice-bar
      left-icon="volume-o"
      wrapable
      :scrollable="false"
      :text="
        cancelTime > 0
          ? `温馨提示：预约开始前` + cancelTime + `分钟无法取消。`
          : `温馨提示：预约开始后` + (0 - cancelTime) + `分钟无法取消。`
      "
    />
    <van-notice-bar
      left-icon="volume-o"
      wrapable
      :scrollable="false"
      text="向左滑动可取消预约"
    />
    <div class="mt-1">
      <div class="mt-1 max-h-64 mb-2 overflow-y-auto overscroll-contain">
        <van-pull-refresh
          v-model="refreshing"
          success-text="加载成功"
          @refresh="onRefresh"
        >
          <van-swipe-cell
            v-for="seatBooking in mySeatBookings"
            :key="seatBooking.id"
          >
            <van-cell
              :title="
                seatBooking.spaceDetailInfo.areaInfo.nameMerge +
                seatBooking.spaceDetailInfo.name
              "
              center
              size="large"
              :label="
                seatBooking.endTime
                  ? `时间：${seatBooking.beginTime.date.slice(
                      5,
                      19
                    )}至${seatBooking.endTime.date.slice(5, 19)}`
                  : `时间：${seatBooking.beginTime.date.slice(5, 19)}至`
              "
            >
              <template #default>
                <van-tag
                  plain
                  :type="
                    [1, 2, 9].includes(seatBooking.status)
                      ? 'success'
                      : 'warning'
                  "
                  ><span class="whitespace-nowrap">{{
                    seatBooking.statusName
                  }}</span></van-tag
                >
              </template>
            </van-cell>
            <template #right v-if="[1, 2, 9].includes(seatBooking.status)">
              <van-button
                class="mt-1.5"
                round
                type="danger"
                text="取消预约"
                @click="cancelBook(seatBooking)"
              />
            </template>
          </van-swipe-cell>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import _ from "lodash";
import { getMyBookings, cancelBooking } from "@/service/home";
import qs from "qs";
import { Dialog } from "vant";
import Cookies from "js-cookie";
export default {
  name: "mySeatBookings",
  components: {},
  setup() {
    const enableRoom = JSON.parse(Cookies.get("school")).enableRoom;
    const user = JSON.parse(Cookies.get("user"));
    const router = useRouter();
    const state = reactive({
      mySeatBookings: [],
      myRoomBookings: [],
      refreshing: false,
      loading: true,
      cancelTime: 1,
      enableRoom: enableRoom,
    });
    const goBack = () => router.go(-1);
    const goHome = () => router.push("/index");
    const onRefresh = async () => {
      loadBookings();
    };
    onMounted(() => {
      loadBookings();
    });
    const loadBookings = async () => {
      const {
        data: { list },
      } = await getMyBookings({
        access_token: user.access_token,
        userid: user.userid,
      });
      state.mySeatBookings = _.filter(list, { isSingle: 1 });
      state.refreshing = false;
      state.cancelTime =
        state.mySeatBookings[0].spaceDetailInfo.categoryInfo.bookRuleInfo.updateTime;
      state.loading = false;
    };
    const cancelBook = async (booking) => {
      try {
        const {
          data: { list }= {},msg
        } = await cancelBooking(
          booking.id,
          qs.stringify({
            id: booking.id,
            _method: "delete",
            access_token: user.access_token,
            userid: user.userid,
          })
        );
        if (list) {
          Dialog.alert({
            title: "提示",
            message: "你已成功取消预约了",
          }).then(() => {
            loadBookings();
          });
        } else {
          Dialog.alert({
          title: "提示",
          message: msg,
        }).then(() => {});
        }
      } catch (error) {
        Dialog.alert({
          title: "提示",
          message: "取消失败",
        }).then(() => {});
      }
    };
    return {
      goBack,
      goHome,
      onRefresh,
      cancelBook,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" >
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
.van-cell__title {
  flex: 1 1 auto;
}
.van-cell__value {
  flex: 1 1 auto;
}
</style>
